import * as Styled from './PunchupTicketInventory.styles';

import { useEffect, useState } from 'react';

import { IdParamsType } from 'utils/types';
import { InventoryTicketTypes } from 'features/common/hooks/useHighlights/types';
import PunchupTicketsAnalyticsCard from 'features/common/components/PunchupTicketsAnalyticsCard/PunchupTicketsAnalyticsCard';
import { TicketTypesInventoryAcc } from '../../types';
import { common } from 'theme';
import { getColor } from 'features/Dashboard/components/utils';
import { useHighlights } from 'features/common/hooks/useHighlights';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PunchupTicketInventory = () => {
	const { t } = useTranslation();
	const { id } = useParams<IdParamsType>();
	const [sold, setSold] = useState(0);
	const [available, setAvailable] = useState(0);

	const { eventHighlights } = useHighlights(id);

	useEffect(() => {
		if (eventHighlights) {
			const acc = eventHighlights.ticket_types_inventory.reduce(
				(acc, ticketTypeInventory) => ({
					sold: (acc.sold += ticketTypeInventory.sold),
					available: (acc.available += ticketTypeInventory.total_amount - ticketTypeInventory.sold),
				}),
				{ sold: 0, available: 0 } as TicketTypesInventoryAcc
			);
			setSold(acc.sold);
			setAvailable(acc.available);
		}
	}, [eventHighlights]);

	return (
		<Styled.Root data-cy="ticket-inv-graph">
			<Styled.Title>{t('tickets-inventory-title')}</Styled.Title>
			<Styled.ContainerTabsPieCharts>
				<PunchupTicketsAnalyticsCard sold={sold} available={available} color={common.colors.orange2} />
				{/* TODO fix responsive on tablet */}
				<Styled.SmallTicketsContainer>
					{eventHighlights?.ticket_types_inventory?.map((ticketType: InventoryTicketTypes, i: number) => (
						<PunchupTicketsAnalyticsCard
							sm
							key={ticketType.ticket_type_id}
							value={ticketType.name}
							sold={ticketType.sold}
							available={ticketType.total_amount - ticketType.sold}
							color={getColor(i)}
						/>
					))}
				</Styled.SmallTicketsContainer>
			</Styled.ContainerTabsPieCharts>
		</Styled.Root>
	);
};

export default PunchupTicketInventory;
